import { TrashIcon } from '@icons';
import { Button, IconButton } from './button';
import { Tooltip } from './tooltip';
import { Badge } from './badge';

interface PayorCardProps {
    name: string;
    email: string;
    isCurrentUser?: boolean;
    onDelete?: () => void;
    onRestore?: () => void;
    disabled?: boolean;
}

export const PayorCard: React.FC<PayorCardProps> = ({
    name,
    email,
    isCurrentUser = false,
    onDelete,
    onRestore,
    disabled = false
}) => (
    <div className="bg-white border border-neutral-100 flex items-center justify-between gap-4 px-6 py-4 rounded-xl">
        {/* Left side: Name, Email, and optional You badge */}
        <div className="flex flex-col gap-1 min-w-0 flex-1">
            <div className="flex items-center gap-2 min-w-0">
                <span className="text-base leading-6 font-normal text-neutral-950 tracking-[0.16px] truncate">
                    {name}
                </span>
                {isCurrentUser && (
                    <Badge className="flex-shrink-0">You</Badge>
                )}
            </div>
            <span className="text-sm leading-5 font-normal text-neutral-950 tracking-[0.14px] truncate">
                {email}
            </span>
        </div>

        {/* Right side: Action buttons */}
        <div className="flex items-center gap-2 flex-shrink-0">
            {onRestore && (
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={onRestore}
                    aria-label="Restore payor"
                >
                    Restore
                </Button>
            )}

            {onDelete && (
                <Tooltip
                    content="Delete payor"
                    position="top"
                    disabled={disabled}
                >
                    <IconButton
                        variant="secondary"
                        size="lg"
                        dangerOnHover
                        onClick={onDelete}
                        disabled={disabled}
                        aria-label="Delete payor"
                    >
                        <TrashIcon />
                    </IconButton>
                </Tooltip>
            )}
        </div>
    </div>
);
